import {
  getLogValue,
  useRequestLatestEditLog,
} from '@op/pages/feeds/hooks/useFeedsRequest';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';

/**
 * 处理Topic的分数
 * @param data 评论数据
 * @param realValue log数据
 * @param needRequest 是否需要请求接口获取log值
 * @param type 公共和新闻两个类型，两个类型的参数不一致
 * @returns
 */
export function useTopic({
  data,
  realValue,
  needRequest = false,
  type = 'common',
}: {
  data: any;
  realValue?: string;
  needRequest?: boolean;
  type?: 'common' | 'news';
}) {
  const dataMemo = useMemo(() => {
    return data ? [data] : [];
  }, [data]);

  // 获取最后一条log的值
  const { logCommentMap } = useRequestLatestEditLog({
    data: dataMemo,
    needRequest: needRequest,
    otherParams: type === 'news' ? { type: 1 } : {},
    type: ['topic'],
  });

  const [newTopic, setNewTopic] = useState<string>(data.topic);
  const [filter, setFilter] = useState(null);

  function changeNewTopic(value: string) {
    setNewTopic(value);
  }

  useEffect(() => {
    let {
      topic,
      unified_id,
      edition_id,
      comment_time,
      comment_uin,
      create_time,
      edition_unified_id,
      md5_uni,
      release_time,
    } = data;

    let defaultValue: string = topic;

    // 如果有真值，那么就设置真值为默认值
    if (realValue) {
      defaultValue = realValue;
    } else {
      const requestValue = getLogValue(
        logCommentMap,
        data,
        'latest_topic',
      ) as string;
      if (needRequest && requestValue) {
        defaultValue = requestValue;
      }
    }

    let commonFilter: any = {
      unified_id: unified_id,
      edition_id: edition_id,
      comment_time: moment(comment_time).format('YYYY-MM-DD HH:mm:ss'),
      comment_uin: comment_uin,
      comment_create_time: moment(create_time).format('YYYY-MM-DD HH:mm:ss'),
      type: 5,
    };

    if (type === 'news') {
      commonFilter = {
        edition_unified_id: edition_unified_id,
        md5_uni: md5_uni,
        release_time: release_time,
        type: 5,
      };
    }

    setFilter(commonFilter);
    setNewTopic(defaultValue);
  }, [data, realValue, logCommentMap]);

  return {
    filter,
    changeNewTopic,
    newTopic,
  };
}
